module.exports = __webpack_public_path__ + "media/components/assets/img/icons/invoice-332fd331425495e8dcda81e5f2c6dfa4.svg";